import React from 'react';
import { MdCheckCircle } from 'react-icons/md';
import {
  SkillLoadChipWrapper,
  SetupStepPill,
  ToolChipSpinner,
} from './Chat.styled';
import { useSkillLoadLabel } from './skillLoadLabel';

/**
 * Durable transcript entry for a skill the agent loaded. Reuses the setup
 * block's pill so a skill load keeps reading as setup rather than as a tool
 * call. The skill's guidance is admin-only and is never rendered here.
 */
const SkillLoadChip: React.FC<{ skill?: string; executing?: boolean }> = ({
  skill,
  executing = false,
}) => {
  const label = useSkillLoadLabel(skill, !executing);

  return (
    <SkillLoadChipWrapper data-testid="skill-load-chip">
      <SetupStepPill $complete={!executing}>
        {executing ? <ToolChipSpinner /> : <MdCheckCircle size={16} />}
        {label}
      </SetupStepPill>
    </SkillLoadChipWrapper>
  );
};

export default SkillLoadChip;
